import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DatepickerHeaderComponent} from "./datepicker-header/datepicker-header.component";
import {MyDate} from "../../../entities/MyDate";
import {MatDatepicker} from '@angular/material/datepicker';


@Component({
  selector: 'app-ble-datepicker',
  templateUrl: './ble-datepicker.component.html',
  styleUrls: ['./ble-datepicker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BleDatepickerComponent implements OnInit {

  @Input() valore?: Date;
  @Input() testo?: string;
  @Input() maxDate?: Date;
  @Input() minDate?: Date;
  @Input() block?: boolean;
  @Input() minLatest?: boolean;
  @Input() hidden ? = false;
  @Input() invalid ? = false;
  @Input() clear ? = false;
  @Input() invalidSet ? = false;
  @Input() autolock?: boolean;
  @Input() full ? = true;
  @Input() type: 'month' | 'year' | 'multi-year' = 'month';

  @Output() cambioValore = new EventEmitter();

  dataPickerHeader = DatepickerHeaderComponent;

  min?: Date = this.minDate;

  defaultValue: Date;
  nomeMese?: Date;

  constructor() {
  }

  ngOnInit() {
    if (this.clear == true && this.minLatest){
      if (this.valore) {
        this.clear = false;
      }
    }
    this.min = this.minDate;
    if (this.min && this.minLatest == true && this.valore){
       if (this.valore > this.min){
          this.min = this.valore;
       }
    }
    if (this.type == 'year') {
      this.nomeMese = this.valore;
    }
    if (this.valore){
      this.defaultValue = this.valore;
    }
  }

  getMonth(event: any, picker: MatDatepicker<any>) {
    if (this.type == 'year') {
      this.nomeMese = event;
      picker.close();
      this.cambioValore.emit({type: 'filterData', mese: event.month() + 1, anno: event.year() });
    }

  }

  clearStartDate() {
    this.invalid =this.invalidSet;
    this.valueChange(undefined);
  }

  valueChange(evt: Date|undefined) {
    this.valore = evt;
    if (evt){this.invalid = false;}
    evt && this.cambioValore.emit(new MyDate(evt));
    !evt && this.cambioValore.emit(undefined);
  }

}
